import script from "./viemaoHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./viemaoHeader.vue?vue&type=script&setup=true&lang=js"

import "./viemaoHeader.vue?vue&type=style&index=0&id=366560ba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-366560ba"]])

export default __exports__